import React from "react";

export const ContactPage = () => <h1>Contact Page</h1>